import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const items = [
  {
    q: "What is your management fee structure?",
    a: "We operate on a transparent percentage of nightly revenue — no setup fees, no hidden costs. The exact rate depends on property size, location, and services selected. We'll walk you through it in a discovery call.",
  },
  {
    q: "Which platforms do you list on?",
    a: "We syndicate to Airbnb, VRBO, Booking.com, and select direct-booking channels. Calendars are synced in real time to prevent double bookings.",
  },
  {
    q: "How do you vet guests?",
    a: "Every reservation is manually reviewed. We verify ID, cross-check reviews across platforms, and require signed rental agreements for stays over a set threshold.",
  },
  {
    q: "Do I need to provide anything?",
    a: "Just the property. We handle staging recommendations, professional photography, linens program, consumables restocking, and everything in between.",
  },
  {
    q: "What service areas do you cover?",
    a: "We currently manage properties across select metros and coastal markets. Submit an inquiry with your property's location and we'll confirm availability within 24 hours.",
  },
  {
    q: "How quickly can we go live?",
    a: "Most homes are listed and taking bookings within 10&ndash;14 days of onboarding, subject to photography scheduling and platform approvals.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-cream py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.3em] uppercase text-brass mb-6">Frequently Asked</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-espresso font-light">
              Answers before <em className="not-italic text-brass">you ask.</em>
            </h2>
            <p className="mt-6 text-espresso/70 max-w-md">
              Still curious? We&rsquo;re happy to walk through your specific property
              on a no-pressure call.
            </p>
          </div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {items.map((it, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-espresso/15" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-serif text-xl lg:text-2xl text-espresso hover:no-underline py-6">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-espresso/70 text-base leading-relaxed pb-6 pr-6">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
